// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3Lr_6","inner":"Form_inner__2cUP2","range":"Form_range__1Cj-j","name":"Form_name__3jlyQ","actions":"Form_actions__c-ZEK"};